export const getActiveStates = (statefulVarsWithValues) =>
  statefulVarsWithValues.reduce((acc, variable) => {
    const { value, stateset, quality = 1 } = variable;

    const states = [];
    let isActive = false;

    stateset?.states.forEach((state) => {
      const { trigger } = state;
      switch (trigger.condition) {
        case '=':
          isActive = value === trigger.triggerValue;
          break;
        case '<>':
          isActive = value > trigger.triggerValue1 && value < trigger.triggerValue2;
          break;
        case '>':
          isActive = value > trigger.triggerValue;
          break;
        case '<':
          isActive = value < trigger.triggerValue;
          break;
        case '<=':
          isActive = value <= trigger.triggerValue;
          break;
        case '>=':
          isActive = value >= trigger.triggerValue;
          break;
        default:
          break;
      }

      if (isActive) {
        states.push({ ...state, quality });
      }
    });
    return [...acc, ...states];
  }, []);

export default getActiveStates;
